import React, { useState, useEffect } from "react";
import AnniversaryGallery from "./AnniversaryGallery.jsx";
import SeminarGallery from "./SeminarGallery.jsx";
import AwardGallery from "./AwardGallery.jsx";
import "../static/css/Gallery.css";

const Gallery = () => {
  const [activeEvent, setActiveEvent] = useState("anniversary");

  return (
    <div className="gallery-main-container">
      <div className="gallery-header-section">
        <h2 className="gallery-title">Gallery</h2>
        <div className="gallery-button-group">
          <button
            className={activeEvent === "anniversary" ? "gallery-btn active" : "gallery-btn"}
            onClick={() => setActiveEvent("anniversary")}
          >
            Anniversary
          </button>
          <button
            className={activeEvent === "seminar" ? "gallery-btn active" : "gallery-btn"}
            onClick={() => setActiveEvent("seminar")}
          >
            Seminar
          </button>
          <button
            className={activeEvent === "award" ? "gallery-btn active" : "gallery-btn"}
            onClick={() => setActiveEvent("award")}
          >
            Award
          </button>
        </div>
      </div>

      <div className="gallery-content-display">
        {activeEvent === "anniversary" && <AnniversaryGallery />}
        {activeEvent === "seminar" && <SeminarGallery />}
        {activeEvent === "award" && <AwardGallery />}
      </div>
    </div>
  );
};

export default Gallery;
